<template>
  <div style="height: 100%">
    <transition key="corridor" mode="out-in" enter-active-class="animated fadeIn"
                leave-active-class="animated fadeOut">
      <router-view @play-sound="playSound"></router-view>
    </transition>
  </div>
</template>

<script>
  export default {
    name: "Corridor",
    methods: {
      playSound(soundName, volume) {
        this.$emit("play-sound", soundName, volume);
      }
    }
  }
</script>

<style scoped>
  @import "~animate.css";
</style>